module.exports = __webpack_public_path__ + "img/ccii.fd825922.svg";